import { useNavigate } from "react-router-dom";

export default function HeritageSection() {
 
    const navigate = useNavigate()
 
    return (
      <div className="bg-[#945042] text-white py-44 p-10 flex flex-col justify-center relative">
        <div className="max-w-5xl mx-auto">
          <div className="bg-[#5C000D] text-white px-6 py-2 inline-block text-lg font-bold uppercase">
            The Heritage
          </div>
          <h2 className="mt-4 text-4xl font-light">OF THE UNITED ARAB EMIRATES</h2>
          <div className="w-20 h-1 mt-2 bg-[#5C000D]"></div>
          <p className="mt-4 font-semibold text-white text-md">
            The Festival provides you with the unique opportunity to learn about the culture and heritage of the UAE, based on a history rich in tradition and instilled noble values. Throughout the history of the UAE, the people of these good lands have proved that they could weather all the hardships, taking fearless strides to lay down the foundations for a prosperous and developed society that encompasses the rich history of the United Arab Emirates.
          </p>
        </div>
        <div className="absolute flex items-end bottom-10 right-10">
          <div className="relative w-56 h-56">
            <div className=" mt-10  bg-[#A65F48] rounded-full opacity-50"></div>
            <img
              src="/red.png"
              alt="UAE Heritage"
              className="object-cover w-full h-full rounded-full "
            />
          </div>
        </div>
      </div>
    );
  }